import { apiUrl } from "../utils/constants";
import { GET, POST, PATCH, DELETE } from "./api.service.wrapper";

const normalizeCountyList = (result) => {
  if (Array.isArray(result?.data?.data)) return result.data.data;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result)) return result;
  return [];
};

export const mapCountyOptions = (list = []) =>
  list
    .filter((county) => county.is_active !== false)
    .map((county) => ({
      label: county.name,
      value: county.id,
    }));

/** Map API new_county payload into react-select option values. */
export const resolveSelectedCounties = (userData = {}, options = []) => {
  const raw = userData.new_county ?? userData.counties ?? userData.county_ids ?? [];

  return (Array.isArray(raw) ? raw : raw ? [raw] : [])
    .map((item) => {
      if (item && typeof item === "object") {
        const value = item.id ?? item.value ?? item.county_id;
        if (value === undefined || value === null) return null;
        const label =
          item.name ||
          item.label ||
          options.find((option) => String(option.value) === String(value))
            ?.label;
        return { label: label || String(value), value };
      }
      const match = options.find(
        (option) => String(option.value) === String(item)
      );
      return match || null;
    })
    .filter(Boolean);
};

/** Format new_county for table/detail display. */
export const formatCountiesDisplay = (value) => {
  if (value === undefined || value === null || value === "") return "-";
  if (typeof value === "string") return value || "-";
  if (Array.isArray(value)) {
    if (value.length === 0) return "-";
    const labels = value
      .map((item) => {
        if (item && typeof item === "object") {
          return item.name || item.label || item.id;
        }
        return item;
      })
      .filter((item) => item !== undefined && item !== null && item !== "");
    return labels.length ? labels.join(", ") : "-";
  }
  if (typeof value === "object") {
    return value.name || value.label || "-";
  }
  return String(value);
};

export const GetCounties = async (options = true) => {
  const params = {};

  if (typeof options === "boolean" || options === null) {
    if (options !== null && options !== undefined) {
      params.is_active = options;
    }
  } else if (typeof options === "object" && options !== null) {
    Object.assign(params, options);
  }

  const response = await GET(apiUrl.county, params);
  return response;
};

export const GetCountyList = async (options = null) => {
  const response = await GetCounties(options);
  return {
    ...response,
    list: normalizeCountyList(response),
  };
};

export const GetCountyById = async (id) => {
  const response = await GET(`${apiUrl.county}/${id}`);
  return response;
};

export const CreateCounty = async (data) => {
  const response = await POST(apiUrl.county, data);
  return response;
};

export const UpdateCounty = async (id, data) => {
  const response = await PATCH(apiUrl.county, id, data);
  return response;
};

export const DeleteCounty = async (id) => {
  const response = await DELETE(apiUrl.county, id);
  return response;
};
